import React from 'react';
import { fmt } from '../ReportTableKit';

const CARDS = [
  { k: 'total', label: 'Total Vouchers', color: '#0f172a' },
  { k: 'expired', label: 'Vouchers Expired', color: '#dc2626' },
  { k: 'issued', label: 'Vouchers Issued', color: '#16a34a' },
  { k: 'available', label: 'Available to Issue', color: '#475569' },
];

export function VoucherSummaryCards({ summary, loading }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0,1fr))', gap: 12, marginBottom: 20 }}>
      {CARDS.map(c => (
        <div key={c.k} className="stat-card" data-testid={`voucher-card-${c.k}`} style={{ padding: 16 }}>
          <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#64748b', fontWeight: 600 }}>{c.label}</div>
          <div data-testid={`voucher-card-${c.k}-value`} style={{ fontSize: 26, fontWeight: 800, color: c.color, marginTop: 6 }}>
            {loading || !summary ? '…' : fmt(summary[c.k])}
          </div>
        </div>
      ))}
    </div>
  );
}
